import React, { Component } from "react";
import Header from "../../../components/header/header";
import Footer from "../../../components/statics/footer";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as ProfessionalProvider from "../../../providers/professionalProvider";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Button,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import "./professionalProfile.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/free-solid-svg-icons";
//import ModalOrder from "./modalOrder";
import { createChat, createConsult } from "../../../providers/chatProvider";
import { createVideochat } from "../../../providers/videochatProvider";
library.add(faStar);

class ProfessionalProfileScreen extends Component {
  constructor() {
    super();
    this.state = {
      categoryName: "",
      contract: false,
      isOrderModalOpen: false,
      basePrice: 0,
      consultType: "",
      confirmModalOpen: false,
      offlineErrorModal: false
    };
  }

  handleContract = () => {
    this.setState(prevState => ({ contract: !prevState.contract }));
  };

  componentDidMount() {
    const {
      match,
      categories,
      subcategories,
      doGetProfessional,
      current_professional
    } = this.props;
    console.log(current_professional);

    if (!current_professional) {
      doGetProfessional(match.params.professionalId);
    }
    /* const category = categories.find(item => item._id == match.params.id);
    if (category) {
      this.setState({ categoryName: category.name });
      return;
    } */
    /* const subcategory = subcategories.find(
      item => item.category.id == match.params.id
    );
    if (subcategory) {
      this.setState({ categoryName: subcategory.category.name });
      return;
    } */
  }

  componentWillMount() {
    // var professional = this.props.history.location.state.professional
    // var category_name = this.props.history.location.state.category_name
    // this.setState({firstName:professional.firstName, lastName:professional.lastName, category_name:"Olá"})
    // if(this.props.history.location.state != undefined){
    //   console.log('oi tem state', this.props.history.location.state)
    // } else {
    //   this.props.history.goBack()
    // }
  }

  beginVideochat = async () => {
    //const { credits } = this.props.user;
    /* const result = await createVideochat(
      this.props.auth.uid,
      this.props.match.params.professionalId,
      credits,
      this.state.basePrice,
      `${this.props.user.first_name} ${this.props.user.last_name}`,
      `${this.props.current_professional.professional.first_name} ${this.props.current_professional.professional.last_name}`
    ); */

    const result = await createConsult(
      {
        customerId: this.props.user._id,
        professionalId: this.props.current_professional.userId._id,
        pricePerHour: this.state.basePrice
      },
      this.props.user.token
    );

    console.log(result);

    if (result.error) {
      return;
    }
    //redirect to video page
    this.props.history.push(`/video/${result._id}`);
  };

  beginChat = async (free = false) => {
    const result = await createChat(
      {
        customerId: this.props.user._id,
        professionalId: this.props.current_professional.userId._id,
        pricePerHour: free ? 0 : this.state.basePrice
      },
      this.props.user.token
    );
    console.log(result);

    if (result.error) {
      return;
    }
    //redirect to chat page
    this.props.history.push("/chat");
  };

  openOrderModal = async (price, type) => {
    const { credits } = this.props.user;

    //if(!credits || parseFloat(credits) < parseFloat(price)){
    /* if (!credits || credits < 1) {
      console.log("redirect to payment");
      this.props.history.push("/credit/checkout");
      return;
    } */

    //verify if the user is online...
    /* const is_online = await ProfessionalProvider.getProfissionalOnlineStatus(
      this.props.match.params.professionalId
    ); */
    //console.log(is_online);
    /* if (!is_online) {
      //open online error modal
      this.setState({ offlineErrorModal: true });
      return;
    } */

    //open modal to confirm the beginning of the chat...
    this.setState({
      confirmModalOpen: true,
      consultType: type,
      basePrice: price
    });

    //this.setState({isOrderModalOpen: true, basePrice:price, consultType: type});
  };

  renderHour = squedule => {
    let day = new Date().getDay() - 1;
    if (day < 0) day = 6;
    const today = squedule[day];
    //console.log(today);

    return (
      <React.Fragment>
        de {today.begin} até {today.end}
      </React.Fragment>
    );
  };

  renderFreeButton = () => {
    const chatRef = `${this.props.auth.uid}+${this.props.match.params.professionalId}`;

    const chat = this.props.chats.find(chat => chat.ref === chatRef);

    let button = (
      <Button outline color="secondary" onClick={() => this.beginChat(true)}>
        Teste gratuito de 5 minutos
      </Button>
    );

    if (!chat) return button;
    if (chat.data.free_sample) return null;
    return button;
  };

  render() {
    if (!this.props.current_professional.userId) return null;

    const {
      firstName,
      lastName,
      isOnline,
      profilePhoto
    } = this.props.current_professional.userId;

    const {
      chatPrice,
      videoPrice,
      professionalDescription,
      categoryId
    } = this.props.current_professional;

    //console.log(this.props.chats);

    return (
      <div className="profile-content">
        {/* <Header /> */}
        <Container>
          <Row className="profile-header">
            <Col md="3 p-0">
              <img src={profilePhoto} />
            </Col>
            <Col md="9 pt-3 pr-3 pl-3 profile-header-right">
              {/* <h3 className="m-0">{this.props.current_professional.firstName} {this.props.current_professional.lastName}</h3> */}
              <Row className="hide-if-mobile">
                <Col>
                  <h3 className="m-0 pl-2 pt-2 name-title">
                    {firstName} {lastName}
                  </h3>
                  <span className="pl-2">{categoryId.name}</span>
                  <ul className="pl-2 mt-4 mb-0">
                    <div className="row ml-0">
                      <FontAwesomeIcon icon={faStar} color="orange" />
                      <FontAwesomeIcon icon={faStar} color="orange" />
                      <FontAwesomeIcon icon={faStar} color="orange" />
                      <FontAwesomeIcon icon={faStar} color="orange" />
                      <FontAwesomeIcon icon={faStarHalf} color="orange" />
                      <p className="ml-2">4,5 / 5,0</p>
                    </div>
                  </ul>
                </Col>
                {/* <Col className="value2 pl-4">
                  <p className="ml-0 mr-0 mb-0 value-by-time-1">
                    Valor por hora (Chat):
                  </p>
                  <p className="ml-0 mr-0 mb-0 pt-0 value-by-time price-1">
                    C$ {chatPrice}
                  </p>
                </Col>
                <Col className="value2 pl-4">
                  <p className="ml-0 mr-0 mb-0 value-by-time-2">
                    Valor por hora (Video):
                  </p>
                  <p className="ml-0 mr-0 mb-0 pt-0 value-by-time price-2">
                    C$ {videoPrice}
                  </p>
                </Col> */}
              </Row>
              <Col className="show-if-mobile">
                <h3 className="name-title">
                  {firstName} {lastName}
                </h3>
                <span className="">{categoryId.name}</span>
                <ul className="mt-4 pl-3 mb-0">
                  <div className="row">
                    <FontAwesomeIcon icon={faStar} color="orange" />
                    <FontAwesomeIcon icon={faStar} color="orange" />
                    <FontAwesomeIcon icon={faStar} color="orange" />
                    <FontAwesomeIcon icon={faStar} color="orange" />
                    <FontAwesomeIcon icon={faStarHalf} color="orange" />
                    <p>4,5 / 5,0</p>
                  </div>
                </ul>
              </Col>
              {/* <div className="value show-if-mobile">
                <p className="m-0 value-by-time">Valor por hora (Chat):</p>
                <p className="m-0 pt-0 value-by-time price">C$ 28.00</p>
              </div>
              <div className="value show-if-mobile">
                <p className="m-0 value-by-time">Valor por hora (Video):</p>
                <p className="m-0 pt-0 value-by-time price">C$ 38.00</p>
              </div> */}
              {/* <span>{this.state.category_name}</span> */}

              <Row className="profile-header-right-list">
                <h5>Habilidades Profissionais</h5>
                <ul>
                  <li>Revisão de documentos</li>
                  <li>Palestras em eventos</li>
                  <li>Coach</li>
                </ul>
              </Row>
              <Row className="profile-header-right-list">
                <ul>
                  <li>Marketing</li>
                  <li>Acompanhamento de Carreira</li>
                </ul>
              </Row>
              <Row className="justify-content-end ml-3 mr-3 pb-3 up">
                <Col sm="6" xs="12">
                  <Button
                    className="btn-block py-2"
                    onClick={this.handleContract}
                  >
                    Solicitar Consulta
                  </Button>
                </Col>
              </Row>
              <Row className="justify-content-end mt-0 ml-3 mr-3 pb-3">
                <Col sm="6" xs="12">
                  <Collapse
                    isOpen={this.state.contract}
                    className="contract-collapse"
                  >
                    <Button
                      className="btn-block btn-collapse"
                      onClick={() => this.openOrderModal(chatPrice, "chat")}
                    >
                      Chat
                    </Button>
                    <Button
                      className="btn-block btn-collapse ml-2"
                      onClick={() => this.openOrderModal(videoPrice, "video")}
                    >
                      Video
                    </Button>
                  </Collapse>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="profile-body">
            <Col md="p-0 profile-body-left hide-if-mobile-profile">
              <ul>
                <li>
                  <span>Status:</span>
                  <p>{isOnline ? "Online" : "Offline"} agora</p>
                </li>
                {/* <li>
                  <span>Horário:</span>
                  <p>{this.renderHour(schedule)}</p>
                </li> */}
                {/* <li><span>Classificação:</span><p>1˚ lugar</p></li>
                  <li><span>Consultorias realizadas:</span><p>3452</p></li>
                  <li><span>Ingressou:</span><p>Há 6 meses</p></li> */}
              </ul>
            </Col>
            <Col md="p-3 profile-body-right hide-if-mobile-profile">
              <h5 className="mt-1">
                Sobre{" "}
                <span className="about-name">
                  {firstName} {lastName}
                </span>
              </h5>
              <p className="mt-4">{professionalDescription}</p>
            </Col>
            <Col md="3 p-0 profile-body-left-mobile show-if-mobile-profile">
              <ul className="list-info">
                <li>
                  <span>Status:</span>
                  <p>{isOnline ? "Online" : "Offline"} agora</p>
                </li>
                {/* <li>
                  <span>Horário:</span>
                  <p>{this.renderHour(schedule)}</p>
                </li> */}
                {/* <li><span>Classificação:</span><p>1˚ lugar</p></li>
                  <li><span>Consult.</span><br/><span>realizadas:</span><p>3452</p></li>
                  <li><span>Ingressou:</span><p>Há 6 meses</p></li> */}
              </ul>
            </Col>
            <Col md="9 p-3 profile-body-right-mobile show-if-mobile-profile">
              <h3 className="m-0">Sobre</h3>
              <p>{professionalDescription}</p>
            </Col>
          </Row>
        </Container>
        <Footer />

        {/* <ModalOrder 
              isOpen={this.state.isOrderModalOpen}
              toggle={() => this.setState({isOrderModalOpen: !this.state.isOrderModalOpen})}
              schedule={schedule}
              type={this.state.consultType}
              professional={this.props.match.params.professionalId}
              professionalName={`${firstName} ${lastName}`}
              customerName={`${this.props.user.firstName} ${this.props.user.lastName}`}
              customer={this.props.auth.uid}
              price={this.state.basePrice}
              categoryName={this.state.categoryName}
            /> */}

        <Modal
          isOpen={this.state.confirmModalOpen}
          toggle={() => this.setState({ confirmModalOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({ confirmModalOpen: false })}
          >
            Iniciar {this.state.consultType}
          </ModalHeader>
          {/* <ModalBody>
            Será cobrado {this.state.basePrice} créditos por hora
          </ModalBody> */}
          <ModalBody>
            Deseja iniciar uma consulta por {this.state.consultType} agora?
          </ModalBody>
          <ModalFooter>
            {/* this.state.consultType === "chat" ? this.renderFreeButton() : null */}
            <Button
              color="danger"
              onClick={() => this.setState({ confirmModalOpen: false })}
            >
              Cancelar
            </Button>

            <Button
              onClick={
                this.state.consultType === "chat"
                  ? () => this.beginChat()
                  : () => this.beginVideochat()
              }
            >
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>

        {/* <Modal
          isOpen={this.state.offlineErrorModal}
          toggle={() => this.setState({ offlineErrorModal: false })}
        >
          <ModalBody>O consultor não está disponível no momento</ModalBody>
        </Modal> */}
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doGetProfessional: id =>
      dispatch(ProfessionalProvider.getProfessionalById(id))
  };
};
const mapStateToProps = state => {
  return {
    professionals: state.professional.list,
    current_professional: state.professional.current_professional,
    categories: state.category.list,
    subcategories: state.category.subcategories,
    user: state.user.userInfo,
    chats: state.chats.list
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProfessionalProfileScreen));
